import invariant from 'tiny-invariant';
import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';
import hoistStatics from 'hoist-non-react-statics';

const createNamedContext = name => {
  const context = /*#__PURE__*/createContext();
  context.displayName = name;
  return context;
};

const context = /* #__PURE__ */createNamedContext('Analytics');

const AnalyticsProvider = ({
  children,
  instance
}) => {
  invariant(instance, `Analytics instance not provided to <AnalyticsProvider />`);
  return /*#__PURE__*/jsx(context.Provider, {
    value: instance,
    children: children || null
  });
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded = ["wrappedComponentRef"];
function withAnalytics(Component) {
  const displayName = `withAnalytics(${Component.displayName || Component.name})`;

  const C = props => {
    const {
      wrappedComponentRef
    } = props,
          remainingProps = _objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/jsx(context.Consumer, {
      children: context => {
        invariant(context, `You should not use ${displayName} outside of a <AnalyticsProvider>`);
        return /*#__PURE__*/jsx(Component, _extends({}, remainingProps, {
          analytics: context,
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;
  return hoistStatics(C, Component);
}

const useAnalytics = () => {
  return useContext(context);
};
const useTrack = () => {
  return useContext(context).track;
};
const usePage = () => {
  return useContext(context).page;
};
const useIdentify = () => {
  return useContext(context).identify;
};

const AnalyticsConsumer = context.Consumer;

export { AnalyticsConsumer, context as AnalyticsContext, AnalyticsProvider, useAnalytics, useIdentify, usePage, useTrack, withAnalytics };
//# sourceMappingURL=index.modern.js.map
